import { gql } from "@apollo/client";

export const CREATE_INCOME_HEAD = gql`
  mutation CreateIncomeHead(
    $incomeType: String
    $note: String
    $incomeHead: String
    $unit: String
    $price: Float
  ) {
    createIncomeHead(
      incomeType: $incomeType

      note: $note
      incomeHead: $incomeHead
      unit: $unit
      price: $price
    ) {
      status
      message
    }
  }
`;

export const GET_INCOME_HEADS = gql`
  query GetIncomeHeads {
    getIncomeHeads {
      _id
      incomeType
      price
      note
      incomeHead
      unit
    }
  }
`;

export const GET_INCOMEHEAD_PAGINATION = gql`
query GetIncomeHeadPagination($page: Int!, $limit: Int!, $keyword: String) {
  getIncomeHeadPagination(page: $page, limit: $limit, keyword: $keyword) {
    data {
      _id
      incomeType
      price
      note
      incomeHead
      unit
    }
    paginator {
      slNo
      prev
      next
      perPage
      totalPosts
      totalPages
      currentPage
      hasPrevPage
      hasNextPage
      totalDocs
    }
  }
}
`;

export const UPDATE_INCOME_HEADS = gql`
  mutation UpdateIncomeHead(
    $id: String!
    $incomeType: String
    $price: Float
    $note: String
    $incomeHead: String
    $unit: String
  ) {
    updateIncomeHead(
      _id: $id
      incomeType: $incomeType
      price: $price
      note: $note
      incomeHead: $incomeHead
      unit: $unit
    ) {
      status
      message
    }
  }
`;

export const DELETE_INCOME_HEADS = gql`
  mutation DeleteIncomeHead($id: String!) {
    deleteIncomeHead(_id: $id) {
      status
      message
    }
  }
`;
